import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

function DialogTailwind({ children, initState }) {
    const [type, setType] = useState('warning');
    const [message, setMessage] = useState('Warning Message');
    const [isOpen, setIsOpen] = useState(true)
    const [isShow, setIsShow] = useState(true)

    const overlayClass = cx('fixed z-30 inset-0 overflow-y-auto', {
        hidden: !isOpen,
    });
    const dialogClass = cx('relative mx-auto mt-20', {
        'grid grid-cols-4 gap-4 w-2/12 md:w-2/3': true,
        'opacity-0': !isOpen,
        'scale-95': !isOpen,
        'opacity-100': isOpen,
        'scale-100': isOpen,
    });

    useEffect(()=>{
        if (children.type) {
            setType(children.type)
        }
        if (children.message) {
            setMessage(children.message)
        }
        if (typeof children !== 'object') {
            if (typeof children === 'string') {
                setMessage(children)
            } else {
                setIsShow(false)
            }
        }
    },[isShow])

    return (
        isShow&&
        <>
            <div className={overlayClass}>
                <div className="flex items-center justify-center min-h-screen">
                    <div className={dialogClass}>
                        <div className="flex flex-col items-center justify-center w-[300px] gap-4 bg-[#B9DFC5] shadow-my-green rounded-lg shadow-lg overflow-hidden">
                            <div className='py-4'>
                                <span>{type}</span>                                
                            </div>
                            <div className="px-4 py-[2rem] flex justify-center items-center break-normal text-center">
                                <p>{message}</p>
                            </div>
                            <div className="px-4 py-2 bg-gray-100 text-right w-full">
                                <button
                                    type="button"
                                    className="text-[#000000] hover:text-gray-700 focus:outline-none w-full"
                                    onClick={() => { 
                                        setIsOpen(false) 
                                        initState('')
                                    }}
                                >
                                    ปิด
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

DialogTailwind.propTypes = {
    children: PropTypes.node.isRequired,
    initState : PropTypes.func.isRequired,
};
export default DialogTailwind